import { Component, OnInit, OnDestroy, HostListener, ElementRef, TemplateRef, ViewChild } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { SystemSiteService } from 'app/services/system-site.service';
declare const $: any;
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-presentation',
    templateUrl: './presentation.component.html',
    styleUrls: ['./presentation.component.scss']
})

export class PresentationComponent implements OnInit, OnDestroy {
    @ViewChild('testimonialModal') testimonialModal: TemplateRef<any>;
    model = {
        left: true,
        middle: false,
        right: false
    };
    date: Date = new Date();
    activeTab = 1;
    activeTab1 = 1;
    activeTab2 = 2;

    images = ['./assets/img/logos/w_ampath.png',
        './assets/img/logos/w_pathcare.png',
        './assets/img/logos/w_path24.png',
        './assets/img/logos/w_toga.png',
        './assets/img/logos/w_jdj.png'

    ];

    Data: any = [];
    selectedItem: any = null; d

    testimonialSubscription: Subscription = null;
    isModalOpen = false;

    constructor(public el: ElementRef, private meta: Meta, private title: Title, private systemSiteService: SystemSiteService, private modalService: NgbModal) {



        this.meta.addTags([
            { name: 'description', content: 'Home page of eMD Technologies' },
            { name: 'author', content: 'eMD Technologies' },
            { name: 'keywords', content: 'Practice Management Solutions, Healthcare' }
        ]);
        this.setTitle('eMD Technologies Home Page');
    }
    public setTitle(newTitle: string) {
        this.title.setTitle(newTitle);
    }

    openModal(item: any) {
        this.selectedItem = item;
        this.modalService.open(this.testimonialModal, {
            centered: true,
            size: 'lg' // large modal for better content display
        });
    }



    LoadData() {
        this.testimonialSubscription = this.systemSiteService.get_testimonial().subscribe({
            next: (data) => {
                console.log(data.result_data)
                this.Data = data.result_data;

            },
            error: (error) => { console.log(error) },
        })
    }



    @HostListener('window:scroll', ['$event'])
    checkScroll() {
        const componentPosition = document.getElementsByClassName('add-animation');
        const scrollPosition = window.scrollY;

        for (var i = 0; i < componentPosition.length; i++) {
            var rec = componentPosition[i].getBoundingClientRect().top + window.scrollY + 100;
            if (scrollPosition + window.innerHeight >= rec) {
                componentPosition[i].classList.add('animated');
            } else if (scrollPosition + window.innerHeight * 0.8 < rec) {
                componentPosition[i].classList.remove('animated');
            }
        }
    }
    ngOnInit() {
        var body = document.getElementsByTagName('body')[0];
        body.classList.add('presentation-page');
        body.classList.add('loading');
        var navbar = document.getElementsByTagName('nav')[0];
        ////navbar.classList.add('navbar-transparent');

        // IsoGrid(document.querySelector('.isolayer--deco1'), {
        //     transform : 'translateX(33vw) translateY(-340px) rotateX(45deg) rotateZ(45deg)',
        //     stackItemsAnimation : {
        //         // properties(pos) {
        //         //     return {
        //         //         translateZ: (pos + 1) * 30,
        //         //         rotateZ: Math.floor(Math.random() * (4 - (-4) + 1)) + (-4)
        //         //     };
        //         // },
        //         options(pos, itemstotal) {
        //             return {
        //                 type: dynamics.bezier,
        //                 duration: 500,
        //                 points: [{"x":0,"y":0,"cp":[{"x":0.2,"y":1}]},{"x":1,"y":1,"cp":[{"x":0.3,"y":1}]}],
        //                 delay: (itemstotal-pos-1)*40
        //             };
        //         }
        //     }
        // });
        this.LoadData();
    }
    ngOnDestroy() {

        if (this.testimonialSubscription)
            this.testimonialSubscription.unsubscribe();

        var body = document.getElementsByTagName('body')[0];
        body.classList.remove('presentation-page');
        body.classList.remove('loading');
        var navbar = document.getElementsByTagName('nav')[0];
        navbar.classList.remove('navbar-transparent');



    }
}
